export enum TableMode {
    LandBased = 'LandBased',
    Online = 'Online'
}

export enum WorkerAccessLevel {
    None = 'None',
    Croupier = 'Croupier',
    Supervisor = 'Supervisor'
}

export enum AppPhase {
    WaitingForCroupier = 'WaitingForCroupier',
    WaitingForPlayers = 'WaitingForPlayers',
    NewRoundPreparation = 'NewRoundPreparation',
    BetsOpen = 'BetsOpen',
    BetsClosed = 'BetsClosed',
    DealingCards = 'DealingCards',
    RoundEnd = 'RoundEnd',
    ShoeChange = 'ShoeChange',
    CardBurn = 'CardBurn',
    RoundVoid = 'RoundVoid',
    RoundError = 'RoundError',
    Decision = 'Decision',
    TableClosed = 'TableClosed'
}

export enum DealingSubPhase {
    FaceDown = 0,
    Dealing = 1,
    SideSelectionAnimation = 2,
    LeftSide = 3,
    RightSide = 4
}

export enum SupervisorSubPhase {
    WaitingForSupervisor = 'WaitingForSupervisor',
    GameSelection = 'GameSelection',
    ConfirmGameSelection = 'ConfirmGameSelection',
    ConfirmAction = 'ConfirmAction',
    ActionSelection = 'ActionSelection'
}

export enum DealerConsoleAction {
    ChangeShoe = 'ChangeShoe',
    ShoeChanged = 'ShoeChanged',
    CloseTable = 'CloseTable'
}

export enum FlagStateType {
    ChatEnabled = 'ChatEnabled',
    RoundFlagged = 'RoundFlagged',
    RoundBetsFree = 'RoundBetsFree',
    TableClosingRequested = 'TableClosingRequested',
    SupervisorCalled = 'SupervisorCalled',
    ResultConfirmed = 'ResultConfirmed'
}

export enum DealerAssistTableErrorCode {
    BackendDisconnected = 'BackendDisconnected',
    RoundOpeningFailed = 'RoundOpeningFailed',
    RoundResultSavingFailed = 'RoundResultSavingFailed'
}

export enum NotificationCode {
    AuthenticationFailed = 'AuthenticationFailed',
    AuthenticationSuccess = 'AuthenticationSuccess',
    CroupierChangeInvalidState = 'CroupierChangeInvalidState',
    DuplicateCard = 'DuplicateCard',
    FlagFailed = 'FlagFailed',
    InvalidCard = 'InvalidCard',
    InvalidCroupierId = 'InvalidCroupierId',
    ScannerDisconnected = 'ScannerDisconnected',
    ScannerConnected = 'ScannerConnected',
    ExpectedSupervisor = 'ExpectedSupervisor'
}

export enum NotificationSeverity {
    Info = 'Info',
    Warning = 'Warning',
    Error = 'Error'
}

export enum GameType {
    Baccarat = 'Baccarat',
    DragonTiger = 'DragonTiger',
    ThreeHeadedDragon = 'ThreeHeadedDragon',
    OpenBaccarat = 'OpenBaccarat',
    OpenDragonTiger = 'OpenDragonTiger'
}
